import Hyperbeam from '@hyperbeam/web';
import { atom } from 'jotai';

type HyperbeamInstance = Awaited<ReturnType<typeof Hyperbeam>>;

interface BrowserSessionState {
  instance: HyperbeamInstance | null;
  sessionId: string | null;
  containerElement: HTMLDivElement | null;
}

/**
 * Global atom to persist browser session state across component re-renders.
 * Once a session is created, it persists until explicitly cleared.
 */
export const browserSessionAtom = atom<BrowserSessionState>({
  instance: null,
  sessionId: null,
  containerElement: null,
});

// Synchronous flag read by recording-manager's beforeunload to skip its native dialog when the user has already confirmed exit via the Hyperbeam back trap; React/Jotai state would not flush in time for beforeunload.
let intentionalUtExitFlag = false;

export const setIntentionalUtExit = (value: boolean): void => {
  intentionalUtExitFlag = value;
};

export const getIntentionalUtExit = (): boolean => intentionalUtExitFlag;
